import {
	AlertCircle,
	ArrowDown,
	ArrowDownAZ,
	ArrowLeft,
	ArrowLeftFromLine,
	ArrowRight,
	ArrowRightFromLine,
	ArrowUp,
	AudioLines,
	Bot,
	Captions,
	Check,
	ChevronDown,
	ChevronLeft,
	ChevronRight,
	ChevronsUpDown,
	ChevronUp,
	CircleAlert,
	CircleCheck,
	CircleHelp,
	CircleSlash2,
	CloudCheck,
	CloudDownload,
	CloudUpload,
	Command,
	CornerDownLeft,
	Dot,
	EllipsisVertical,
	ExternalLink,
	Eye,
	File,
	FileArchive,
	FileAudio,
	FileCheck2,
	FileOutput,
	FileText,
	Filter,
	Folder,
	Globe,
	Grip,
	GripVertical,
	HeartPulse,
	History,
	Inbox,
	Info,
	Languages,
	Layers,
	LayoutTemplate,
	Lightbulb,
	Link2,
	ListChecks,
	ListPlus,
	ListTree,
	LoaderCircle,
	LockKeyhole,
	LogOut,
	Moon,
	Pen,
	Pencil,
	Plus,
	Quote,
	RefreshCcw,
	RefreshCw,
	RotateCcw,
	Search,
	Settings,
	Sparkles,
	SpellCheck,
	SquareChevronRight,
	SquarePen,
	Star,
	StarOff,
	Sun,
	Tag,
	TestTubeDiagonal,
	Trash,
	Trash2,
	TriangleAlert,
	Waypoints,
	Wrench,
	X,
} from "lucide-react";

const preloadedIcons = {
	quote: Quote,
	"test-tube-diagonal": TestTubeDiagonal,
	lightbulb: Lightbulb,
	wrench: Wrench,
	info: Info,
	"circle-alert": CircleAlert,
	"triangle-alert": TriangleAlert,
	search: Search,
	x: X,
	"circle-slash-2": CircleSlash2,
	command: Command,
	"corner-down-left": CornerDownLeft,
	"arrow-down": ArrowDown,
	"arrow-up": ArrowUp,
	check: Check,
	layers: Layers,
	"chevrons-up-down": ChevronsUpDown,
	plus: Plus,
	"loader-circle": LoaderCircle,
	settings: Settings,
	"square-pen": SquarePen,
	"external-link": ExternalLink,
	"file-output": FileOutput,
	star: Star,
	"star-off": StarOff,
	file: File,
	"layout-template": LayoutTemplate,
	inbox: Inbox,
	"square-chevron-right": SquareChevronRight,
	"heart-pulse": HeartPulse,
	"ellipsis-vertical": EllipsisVertical,
	"log-out": LogOut,
	"cloud-download": CloudDownload,
	pencil: Pencil,
	captions: Captions,
	trash: Trash,
	filter: Filter,
	"arrow-down-a-z": ArrowDownAZ,
	"list-tree": ListTree,
	"list-checks": ListChecks,
	eye: Eye,
	"arrow-left": ArrowLeft,
	"arrow-right": ArrowRight,
	"arrow-left-from-line": ArrowLeftFromLine,
	"arrow-right-from-line": ArrowRightFromLine,
	"chevron-down": ChevronDown,
	"chevron-up": ChevronUp,
	"chevron-right": ChevronRight,
	"chevron-left": ChevronLeft,
	sparkles: Sparkles,
	"audio-lines": AudioLines,
	history: History,
	"file-audio": FileAudio,
	"file-archive": FileArchive,
	"circle-check": CircleCheck,
	"alert-circle": AlertCircle,
	"refresh-ccw": RefreshCcw,
	tag: Tag,
	"file-text": FileText,
	"file-check-2": FileCheck2,
	bot: Bot,
	"spell-check": SpellCheck,
	languages: Languages,
	globe: Globe,
	folder: Folder,
	"link-2": Link2,
	"grip-vertical": GripVertical,
	"list-plus": ListPlus,
	waypoints: Waypoints,
	pen: Pen,
	"cloud-upload": CloudUpload,
	"cloud-check": CloudCheck,
	"refresh-cw": RefreshCw,
	"trash-2": Trash2,
	"lock-keyhole": LockKeyhole,
	dot: Dot,
	"rotate-ccw": RotateCcw,
	"circle-help": CircleHelp,
	moon: Moon,
	sun: Sun,
	grip: Grip,
};

export default preloadedIcons;
